import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../../components/formatted-currency/container';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import messages from '../messages';

import style from '../style.module.less';

const ItemUnitCostColumnId = 'unitPrice';

const itemUnitCostBuilder = (item) => {
  return item.unitPrice;
};

const ItemUnitCostCell = ({ cell }) => {
  const { code, value = 0 } = cell.value;

  return (
    <Text
      element='span'
      textType={TextType.Description}
      value={<FormattedCurrency currencyCode={code} value={Math.abs(parseFloat(value))} />}
    />
  );
};

ItemUnitCostCell.propTypes = {
  cell: PropTypes.shape({
    value: CurrencyPropType,
  }).isRequired,
};

const createItemUnitCostColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.itemUnitCost} />,
  accessor: ItemUnitCostColumnId,
  Cell: ItemUnitCostCell,
  width: 1,
  className: style['justify-end'],
});

export { ItemUnitCostColumnId, itemUnitCostBuilder, createItemUnitCostColumnDefinition };
